import TagManager from 'react-gtm-module';
import * as logger from '../lib/logger';

export function trackEvent({ name, category, label, action, value }) {
  const eventNameValidation = /[^a-z_]/g;
  if (eventNameValidation.test(name)) {
    throw new Error(
      `Invalid event name ${name}. Event name must include only a-z and _`,
    );
  }

  const dataLayer = {
    event: name,
    eventProps: { category, action, label, value },
  };

  logger.info('Tracking event', dataLayer);
  TagManager.dataLayer({ dataLayer });
}
